import React from "react";
import {BreadcrumbsComponent} from "./BreadcrumbsComponent";

const containerStyling: React.CSSProperties = {
	display: "flex",
	flexDirection: "column",
	maxHeight: "100%",
	height: "100%",
};

const documentViewerStyle: React.CSSProperties = {
	flexGrow: 1,
	overflow: "auto", // to handle the content that may overflow the div.
};

interface IBreadcrumbsWrapperProps {
	children: React.ReactNode;
	endAdornment?: React.ReactNode;
}

export const BreadcrumbsWrapper: React.FC<IBreadcrumbsWrapperProps> = (props) => {
	return (
		<div style={containerStyling}>
			<BreadcrumbsComponent>{props.endAdornment}</BreadcrumbsComponent>

			<div style={documentViewerStyle}>{props.children}</div>
		</div>
	);
};

